import { render, staticRenderFns } from "./SowList.vue?vue&type=template&id=bfa8849a&"
import script from "./SowList.vue?vue&type=script&lang=js&"
export * from "./SowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports